import React from 'react';

function cleanCanvas({popupClass, children}) {
    return (
        <div className={`${popupClass}`}>{children}</div>
    );
}

export default cleanCanvas;


// WEBPACK FOOTER //
// ./src/fPopup/popup_types/clean-canvas/index.js